<template>
    <el-container>
        <el-header height="auto">
            <el-form :inline="true" :model="queryForm" class="demo-form-inline">
                <el-form-item label="模版名称/系统编码">
                    <el-input size="mini" v-model="queryForm.name" placeholder="模版名称/系统编码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main style="padding: 0">
            <div>
                <el-button size="mini" icon="el-icon-document-add" type="primary" @click="showPop">新增</el-button>
            </div>
            <div>
                <el-table :data="list" style="width: 100%" height="640">
                    <el-table-column type="index" label="序号" width="60"></el-table-column>
                    <el-table-column prop="templateCode" label="模版编码" width="180"></el-table-column>
                    <el-table-column prop="templateName" label="模版名称" width="180"></el-table-column>
                    <el-table-column prop="systemCode" label="系统名称" width="180"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" icon="el-icon-share" type="primary" @click="shareTemplate(scope.$index, scope.row)">分配系统</el-button>
                            <el-button size="mini" icon="el-icon-edit" type="primary" @click="editTemplate(scope.$index, scope.row)">复制</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="paginationStyle" style="padding:0;">
                <el-pagination small layout="prev, pager, next" :page-size="pageSize" :current-page="pageNum" :total="total" @current-change="handleCurrentChange"></el-pagination>
            </div>
        </el-main>
        <index-pop v-if="popFormIsShow" @hide="popFormHide" @save="add" :data="popForm"></index-pop>
        <el-dialog append-to-body :visible="allocationFormIsShow" @close="hideAllocationForm" :close-on-click-modal="true" :close-on-press-escape="true">
            <el-form ref="form" :model="allocationForm" label-width="90px" size="mini">
                <el-form-item label="模版编码">
                    <el-input disabled size="mini" v-model="allocationForm.templateCode"></el-input>
                </el-form-item>
                <el-form-item label="系统简称">
                    <el-input size="mini"  v-model="allocationForm.systemCode"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="hideAllocationForm">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveAllocationForm">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
    import IndexPop from "./IndexPop.vue";
    import designList from "@/views/baseTemplate/designList";
    export default {
        components:{
            IndexPop
        },
        data() {
            return {
                queryForm: {
                    name: ''
                },
                popForm:{
                    pageSize:"100*180",
                    templateName:"测试模版名称",
                    templateCode:"",
                    systemCode:"NVAS",
                    width:"",
                    height:"",
                    conversion:100/380,
                    unit:"px",
                    content:""
                },
                popFormIsShow:false,
                templatePopShow:false,
                templateBoxShow:false,
                list:[],
                pageNum:1,
                pageSize:10,
                total:0,
                name:"",
                allocationForm:{templateCode:"",systemCode:""},
                allocationFormIsShow:false
            }
        },
        methods: {
            onSearch() {
                this.name=this.queryForm.name;
                this.loadList()
            },
            showPop(){
                this.reset(this.popForm);
                this.popForm.content="";//JSON.stringify(designList)
                this.popFormIsShow=true
            },
            popFormHide(){
                this.popFormIsShow=false;
                //this.reset(this.popForm)
            },
            removeTemplate(){
                this.$alert("正在开发中...")
            },
            editTemplate(index,row){
                this.popFormIsShow=true;
                this.popForm={...row}
            },
            add(data){
                const params = {
                    templateName:data.templateName,
                    templateCode:data.templateCode,
                    systemCode:data.systemCode,
                    description:"",
                    width:data.width*10,
                    height:data.height*10,
                    conversion:data.conversion,
                    intOrient:data.intOrient||0,
                    unit:data.unit,
                    content:data.content
                };
                this.axios.post('/template/saveTemplate',params,{packageName:"BASE"}).then(res=>{
                    this.loadList();
                    this.popFormHide();
                });
            },
            reset(data){
                for(let key in data){
                    if(data.hasOwnProperty(key)){
                        data[key]="";
                    }
                }
            },
            shareTemplate(index,row){
                this.allocationFormIsShow=true;
                this.allocationForm={templateCode:row.templateCode,systemCode:row.systemCode};
            },
            loadList(name=this.name,pageNum=this.pageNum){
                this.axios.post('/template/selectTemplate',{
                    filter:name,
                    pageNum:pageNum,
                    pageSize:this.pageSize
                },{packageName:"BASE"}).then(res=>{
                    this.list=res.list;
                    this.total=res.total
                })
            },
            handleCurrentChange(pageNum){
                this.pageNum=pageNum;
                this.loadList()
            },
            hideAllocationForm(){
                this.allocationFormIsShow=false
            },
            saveAllocationForm(){
                this.axios.post('/template/saveTemplateConf',this.allocationForm,{packageName:"BASE"}).then(res=>{
                    this.loadList();
                    this.hideAllocationForm();
                })
            }
        },
        mounted(){
            this.loadList()
        }
    }
</script>
